var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/clock"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 17.0625C4.5525 17.0625 0.9375 13.4475 0.9375 9C0.9375 4.5525 4.5525 0.9375 9 0.9375C13.4475 0.9375 17.0625 4.5525 17.0625 9C17.0625 13.4475 13.4475 17.0625 9 17.0625ZM9 2.0625C5.175 2.0625 2.0625 5.175 2.0625 9C2.0625 12.825 5.175 15.9375 9 15.9375C12.825 15.9375 15.9375 12.825 15.9375 9C15.9375 5.175 12.825 2.0625 9 2.0625Z",
    fill: "#0A5EF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.7825 11.9475C11.685 11.9475 11.5875 11.925 11.4975 11.865L9.17248 10.4775C8.59498 10.1325 8.16748 9.37501 8.16748 8.70751V5.63251C8.16748 5.32501 8.42248 5.07001 8.72998 5.07001C9.03748 5.07001 9.29248 5.32501 9.29248 5.63251V8.70751C9.29248 8.97751 9.51748 9.37501 9.74998 9.51001L12.075 10.8975C12.345 11.055 12.4275 11.4 12.27 11.67C12.1575 11.85 11.97 11.9475 11.7825 11.9475Z",
    fill: "#0A5EF3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.6fd26a0eee53c39056a0231c1cb88ec1.svg";
export { ForwardRef as ReactComponent };